import { SvgIconType } from './svg.interface';

const Basket: SvgIconType = ({
  width = 12,
  height = 12,
  className = '',
  color = '#4F566B'
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.21046 0.012846C7.03115 -0.0351354 6.84737 0.0552223 6.77272 0.218407L5.27556 5.80589C5.16835 6.20599 5.40579 6.61724 5.80589 6.72444C6.20599 6.83165 6.61724 6.59421 6.72444 6.19411L7.17838 4.5H7.17591L8.19945 0.664978C8.25302 0.465315 8.13438 0.260085 7.93445 0.206586L7.21046 0.012846Z"
      fill={color}
    />
    <path
      d="M3.82667 5.41766L4.07255 4.5H0.75C0.335786 4.5 0 4.83579 0 5.25C0 5.66421 0.335786 6 0.75 6L1.42587 11.3328C1.46807 11.7126 1.78912 12 2.17128 12H9.82872C10.2109 12 10.5319 11.7126 10.5741 11.3328L11.25 6C11.6642 6 12 5.66421 12 5.25C12 4.83579 11.6642 4.5 11.25 4.5H8.73129L8.17333 6.58234C7.85171 7.78264 6.61796 8.49495 5.41766 8.17333C4.21736 7.85171 3.50505 6.61796 3.82667 5.41766Z"
      fill={color}
    />
  </svg>
);

export default Basket;
